import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="w-full bg-white border-t border-orange-200 py-8 md:py-12" data-id="element-81">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-83">
          <h3 className="text-2xl font-bold text-orange-500 mb-2 md:mb-4" data-id="element-84">
            RECURSOHUB™
          </h3>

          <p className="text-lg text-gray-900 font-semibold mb-1 md:mb-2" data-id="element-85">
            El sistema N°1 para emprender con minidonas desde casa en Argentina
          </p>

          <p className="text-gray-500 mb-4 md:mb-8" data-id="element-86">
            Porque emprender no debería costar años de prueba y error.
          </p>

          <div className="text-gray-600 mb-4 md:mb-8 space-y-1" data-id="element-87">
            <p data-id="element-88">📧 atencionrecursohub@gmail.com</p>
            <p data-id="element-89">🌐 www.recursohub.com</p>
          </div>

          <div className="text-sm text-gray-400 mb-4 md:mb-6" data-id="element-90">
            <p data-id="element-91">© recursoHUB™ 2026 — Todos los derechos reservados.</p>
            <p data-id="element-92">
              Prohibida la reproducción y redistribución sin autorización
              expresa.
            </p>
          </div>

          <p className="text-xl font-bold text-orange-500 italic" data-id="element-93">
            "La próxima semana puede ser diferente."
          </p>
        </motion.div>
      </div>
    </footer>;
}